import React from 'react'
import PropTypes from 'prop-types'
import { grey600 } from 'material-ui/styles/colors'

const FormLabel = (
  ({
    text,
    dark,
    children,
    style,
  }) => {
    return (
      <p
        style={{
          fontSize: 12,
          color: dark ? grey600 : 'rgba(0, 0, 0, 0.298039)',
          marginBottom: 5,
          ...style,
        }}
      >
        {text}
        {children}
      </p>
    )
  }
)

FormLabel.propTypes = {
  text: PropTypes.string,
}
FormLabel.defaultProps = {
  text: '',
}

export default FormLabel



// WEBPACK FOOTER //
// ./src/components/labels/FormLabel.js